'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = require('./gif');

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gif2.default;
// export default 'data:audio/mp3;base64,audio-focus-test';

module.exports = exports['default'];
//# sourceMappingURL=mp3.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/supports/media/mp3.js
// module id = 69
// module chunks = 0